import Fuse from "fuse.js";
import { useMemo } from "react";
import { FUSE_OPTIONS } from "./fuse-options";

export function useSearchEngine<T>(
  items: T[],
  options: Partial<Fuse.IFuseOptions<T>> = {},
) {
  return useMemo(() => {
    const validItems = Array.isArray(items) ? items : [];
    return new Fuse<T>(validItems, {
      ...FUSE_OPTIONS,
      ...options,
    });
  }, [items, options]);
}
